"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UserSettings;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = _interopRequireDefault(require("FileManagerCore/actions/ActionTypes"));

var defaultState = _immutable.default.Map({});

function UserSettings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      data = action.data,
      userSettings = action.userSettings;

  switch (type) {
    case _ActionTypes.default.SORT:
      if (userSettings) {
        return userSettings;
      }

      return state;

    case _ActionTypes.default.SAVE_USER_SETTINGS_ATTEMPTED:
    case _ActionTypes.default.SAVE_USER_SETTINGS_SUCCEEDED:
      return data;

    case _ActionTypes.default.FETCH_USER_SETTINGS_SUCCEEDED:
      return userSettings;

    default:
      return state;
  }
}

module.exports = exports.default;